import FieldProto from "../../../../fields3/proto/field-proto"
import FieldConfig from "../../../proto/field-config";
import FieldDocumentAccess_View from "./render/view";
import FieldDocumentAccess_ViewSmall from "./render/view-small";

const debug = false
// const debug = "FieldDocumentAccess"

export default class FieldDocumentAccess extends FieldProto {

    constructor(config:FieldConfig) {
        super(config)

        this.typeLabel  = "Document access"


        _.assign(this.renderComponents,{
            view                : FieldDocumentAccess_View,
            viewSmall           : FieldDocumentAccess_ViewSmall
        })
    }

    getDisplayValue(value:any) {

        switch (value) {
            case gd.const.note.access.NOT_SHARED: return 'Myself'
            case gd.const.note.access.FULL      : return 'Full access'
            case gd.const.note.access.STANDARD  : return 'Standard access'
            case gd.const.note.access.LIMITED   : return 'Limited access'
        }

        // switch (value) {
        //     case gd.const.note.access.LIMITED:   return "All users";
        //     case gd.const.note.access.STANDARD:  return "Standard";
        //     case gd.const.note.access.FULL:      return "Full";
        //     case gd.const.note.access.NOT_SHARED:
        //     default:                             return "No access";
        // }


    }

    sortValue(value:any, model:any) {return value}


    // renderGListGroup(value) {
    //     debug && console.log(debug, 'renderGListGroup', value)
    //     return <DocumentAccessValue className       = "ui5-group-by-text-2"
    //                                 iconClassName   = "group-icon"
    //                                 field           = {this}
    //                                 value           = {value}/>
    // }
}